export const MIN_SYSTOLIC_BP = 80;
export const MAX_SYSTOLIC_BP = 180;
export const MIN_DIASTOLIC_BP = 60;
export const MAX_DIASTOLIC_BP = 120;
